import * as Sentry from "@sentry/browser";
import i18n from "i18next";
import XHR from "i18next-xhr-backend";
import {initReactI18next} from "react-i18next";

let language: string | undefined = document.body.dataset.lang;

if (language === undefined) {
  Sentry.captureException("Language code not found in DOM");
  language = "en";
}

function loadLocales(
  url: string,
  options: any,
  callback: (locale: {} | null, status: {status: string}) => void,
) {
  import(`./locales/${url}`)
    .then((locale) => {
      callback(locale.default, {status: "200"});
    })
    .catch(() => {
      callback(null, {status: "404"});
    });
}

i18n
  .use(XHR)
  .use(initReactI18next)
  .init({
    backend: {
      ajax: loadLocales,
      loadPath: "{{lng}}/{{ns}}.json",
      parse: (data: string) => data,
    },
    defaultNS: "default",
    fallbackLng: "en",
    fallbackNS: "default",
    interpolation: {
      escapeValue: false, // not needed for react!!
    },
    keySeparator: false,
    lng: language,
    ns: ["default", "cart", "example", "checkout"],
    nsSeparator: false,
    react: {
      nsMode: "fallback",
      useSuspense: true,
      wait: true,
    },
  });

export default i18n;
